<div class="layout-container">
  <app-sidebar *ngIf="layoutService.showSidebar()" [class.collapsed]="layoutService.isSidebarCollapsed()"
    [userInfoBg]="userInfoBg" [isChangePasswordOpen]="isChangePasswordOpen">
  </app-sidebar>

  <div class="app_body" [class.sidebar-collapsed]="layoutService.isSidebarCollapsed()"
    [class.no-sidebar]="!layoutService.showSidebar()">
    <app-header #headerComp (changePasswordClick)="onChangePasswordPanelToggled(true)"
      (changePasswordPanelToggled)="onChangePasswordPanelToggled($event)"
      (backgroundImageSelected)="onBackgroundImageSelected($event)"
      (backgroundImagePreview)="onBackgroundImagePreview($event)" (themeBtnClick)="onThemeBtnClick()"
      (settingsClick)="onSettingsClick()" (profileDropdownStateChange)="onProfileDropdownStateChange($event)">
    </app-header>

    <main class="main_content" [class.full-width]="!layoutService.showSidebar() || layoutService.isSidebarCollapsed()"
      [class.right-sidebar-collapsed]="(layoutService.isRightSidebarCollapsed$ | async)">
      <div class="content_wrapper">
        <router-outlet></router-outlet>
      </div>

      <!-- Mobile Quick Add Button - Show on screens 1023px and below -->
      <button class="mobile_quick_add radial_menu_btn" (click)="onMobileAddClick()"
        [class.active]="isMobileRadialMenuOpen">
        <img src="assets/images/quick.svg" alt="Add">
        <div class="quick_add_text">
          GET STARTED
        </div>
      </button>

      <div class="right_container">
        <!-- Client Summary Button - Only show on project-details page -->

        <app-right-sidebar class="right_sidebar" *ngIf="showRightSidebar()"></app-right-sidebar>
      </div>

    </main>

    <app-footer></app-footer>
  </div>
</div>

<!-- Change Password Form - Rendered at layout level to cover entire viewport -->
<app-change-password-form *ngIf="isChangePasswordOpen"
  (close)="onChangePasswordPanelToggled(false)"></app-change-password-form>

<!-- Theme Selection Modal - Rendered at layout level to cover entire viewport -->
<app-theme-selection-modal *ngIf="themeSelectionModalOpen" (close)="onCloseThemeSelectionModal()"
  (themeSelected)="onThemeSelected($event)" (themeToggled)="onThemeToggled($event)"
  (themePreview)="onThemePreview($event)">
</app-theme-selection-modal>

<!-- My Settings Modal - Rendered at layout level to cover entire viewport -->
<app-my-settings *ngIf="showSettingsSlider" (close)="onCloseSettingsSlider()" (settingsSaved)="onSettingsSaved($event)">
</app-my-settings>

<!-- Profile Dropdown - Rendered at layout level to appear above right sidebar -->
<div class="profile-dropdown-global" *ngIf="profileDropdownOpen">
  <div class="user-info">
    <a class="name" (click)="navigateToProfileView($event)" style="cursor: pointer;">{{profileDropdownUserName}}</a>
  </div>
  <a class="dropdown-item" (click)="onSettingsClick()">
    <i class="wl_icon_settings"></i>
    My Settings
  </a>
  <button class="dropdown-item" (click)="onThemeBtnClick()">
    <i class="fas fa-palette"></i>
    Theme
  </button>
  <button class="dropdown-item" (click)="onChangePasswordPanelToggled(true)">
    <i class="fas fa-key"></i>
    Change Password
  </button>
  <div class="dropdown-divider"></div>
  <button class="dropdown-item" (click)="onLogoutClick()">
    <i class="fas fa-sign-out-alt"></i>
    Sign Out
  </button>
</div>

<div class="popup-notifications-container" *ngIf="popupNotifications().length > 0">
  <ng-container *ngFor="let popup of popupNotifications(); let i = index">
    <div class="notification-popup" [class.show]="popup.showPopup" [style.bottom.px]="0 + (i * 160)"
      (click)="onPopupClick(popup, $event)">
      <button class="popup-close" (click)="dismissPopup(popup.id, $event)" title="Dismiss">
        <i class="fas fa-times"></i>
      </button>

      <div class="popup-main-content">
        <div class="popup-avatar-wrapper">
          <img *ngIf="popup.user.avatar && !imageLoadError[popup.id]" [src]="popup.user.avatar" [alt]="popup.user.name"
            class="popup-avatar" (error)="onImageError(popup.id)" (load)="onImageLoad(popup.id)">
          <div *ngIf="!popup.user.avatar || imageLoadError[popup.id]" class="popup-avatar-fallback">
            {{ getInitials(popup.user.name) }}
          </div>
          <div class="status-indicator"></div>
        </div>

        <div class="popup-content">
          <h3 class="popup-user-name">{{ popup.user.name }}</h3>
          <p class="popup-title">{{ popup.title }}</p>
          <p class="popup-title">{{ popup.objectname }}</p>
        </div>
      </div>

      <div class="popup-actions">
        <!-- Show check icon for unread, double-tick for read -->
        <button class="popup-action-btn" (click)="markAsRead(popup); $event.stopPropagation()" *ngIf="!popup.isRead"
          title="Mark as read">
          <i class="wl_icon_comment-check"></i>
        </button>
        <button class="popup-action-btn read-indicator" *ngIf="popup.isRead" title="Read">
          <i class="wl_icon_calendar-check"></i>
        </button>
        <!-- <button class="popup-action-btn" (click)="onCommentClick(popup, $event)" title="Comment">
          <i class="wl_icon_comment-notify"></i>
        </button> -->

        <!-- Three dots dropdown -->
        <div class="popup-dropdown-container">
          <button class="popup-action-btn" (click)="togglePopupDropdown(popup.id, $event)" title="More options">
            <i class="wl_icon_doc-3dot"></i>
          </button>

          <!-- Dropdown Menu -->
          <div class="popup-dropdown" *ngIf="isPopupDropdownOpen(popup.id)" (click)="$event.stopPropagation()"
            [class.dropdown-open]="isPopupDropdownOpen(popup.id)">



            <!-- Pin/Unpin -->
            <!-- <button class="dropdown-item" 
                    (click)="onPopupDropdownItemClick(popup, 'pin', $event)">
              <i class="wl_icon_pin"></i>
              <span>{{ popup.isPinned ? 'Unpin' : 'Pin' }}</span>
            </button>
             -->

            <!-- View Details -->
            <button class="dropdown-item" (click)="onPopupDropdownItemClick(popup, 'view-details', $event)">
              <i class="wl_icon_client-quick"></i>
              <span>View Details</span>
            </button>

            <!-- Divider -->
            <div class="dropdown-divider"></div>

          </div>
        </div>
      </div>

      <!-- Countdown Progress Bar -->
      <div class="notification-countdown-bar" [style.animation-duration]="popup.popupTimeout + 'ms'"
        *ngIf="popup.showPopup && !popup.isPinned">
      </div>
    </div>
  </ng-container>
</div>

<!-- Test button for popup notifications (can be removed later) -->
<!-- <button class="test-notification-popup-btn" (click)="testAddNotification()" title="Test Notification Popup">
  <i class="fas fa-bell"></i>
  Test Popup
</button> -->

<!-- Mobile Radial Menu - Show only when mobile quick add is active -->
<div class="mobile_radial_menu" [class.open]="isMobileRadialMenuOpen" (click)="$event.stopPropagation()">
  <!-- Close Button at Center -->
  <button class="radial_menu_close_btn" (click)="onMobileRadialMenuClose($event)" aria-label="Close menu">
    <img src="assets/images/quick.svg" alt="Add">
  </button>

  <!-- Radial Menu Items -->
  <div class="radial_menu_items">
    <div class="radial_menu_item" *ngFor="let item of mobileRadialMenuItems; let i = index" [style.--item-index]="i"
      (click)="onMobileRadialMenuItemClick(item, $event)" [attr.data-tooltip]="item.label">
      <div class="radial_item_content">
        <img [src]="item.icon" [alt]="item.label">
        <span class="radial_item_label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</div>